import { createSelector } from 'reselect';

const sessionState = (state) => state.session;

export const sessionSelector = createSelector(sessionState, (session) => session.session);
